import { useStories } from '../../api/projects.js';
import { Alert, Card, Spinner } from '../../components/ui.js';
import { StoryBoard } from '../../components/StoryBoard.js';
import { useProjectContext } from './ProjectShell.js';

/** Founder-facing board: their stories laid out in lanes by status. */
export function BoardPage() {
  const { project } = useProjectContext();
  const stories = useStories(project.id);
  if (stories.isPending) return <Card>{<Spinner />}</Card>;
  if (stories.isError) return <Card>{<Alert>Could not load the board.</Alert>}</Card>;
  return <StoryBoard stories={stories.data ?? []} />;
}
